import { api } from '../../lib/api.js';
import { BaseComponent } from '../../lib/base-component.js';
import { contactPath } from '../../lib/lists.js';
import { css, html } from '../../lib/lit.js';
import { router } from '../../lib/router.js';

// /beta-queue/<early-access entry id> is a stable link: d3-community's staff
// Discord announcements point here (dice-driven/d3-community#38). The beta queue
// is now a filter on the Lists page, so this looks the entry up and replaces
// itself with that person's page.
class BetaQueueRedirectView extends BaseComponent {
    static properties = {
        entryId: { type: String, attribute: 'entry-id' },
        _error: { state: true },
    };

    static styles = css`
        :host {
            display: block;
        }
        .wrap {
            max-width: 48rem;
            margin: 0 auto;
            padding: 2rem 1rem 4rem;
        }
    `;

    constructor() {
        super();
        this.entryId = '';
        this._error = '';
    }

    updated(changed) {
        if (changed.has('entryId') && this.entryId) {
            this._redirect();
        }
    }

    async _redirect() {
        this._error = '';
        try {
            const entry = await api.get(`/lists/early-access/${encodeURIComponent(this.entryId)}`);
            router.navigate(contactPath(entry.contactId), { replace: true });
        } catch (error) {
            this._error =
                error.status === 404
                    ? 'This sign-up is no longer on early access: they were removed, or it was never confirmed and has expired.'
                    : error.message;
        }
    }

    render() {
        return html`
            <div class="wrap">
                <a class="small" href="/lists"><i class="bi bi-arrow-left"></i> Lists</a>
                ${
                    this._error
                        ? html`<div class="alert alert-danger mt-3" role="alert">${this._error}</div>`
                        : html`<p class="text-muted mt-3">Finding them…</p>`
                }
            </div>
        `;
    }
}

customElements.define('d3-beta-queue-redirect-view', BetaQueueRedirectView);
